import React from "react"
import { Grid, TextField, Autocomplete, Typography, InputAdornment } from "@mui/material"
import CustomDatePicker from "../../../../components/CustomDatePicker"

const TabTransferencia = ({ pago, handleInputChange, cat }) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="subtitle2" color="primary" sx={{ mb: -1 }}>
          Detalle de Transferencia / Depósito Bancario
        </Typography>
      </Grid>

      {/* 1. Banco Receptor de la Compañía (bcombco) */}
      <Grid item xs={12} md={6}>
        <Autocomplete
          options={cat.bancos_transferencia || []}
          getOptionLabel={(option) => option.label || ""}
          value={(cat.bancos_transferencia || []).find((b) => b.id === pago.banco_tarjeta) || null}
          onChange={(e, nv) => {
            handleInputChange("banco_tarjeta", nv ? nv.id : "")
            handleInputChange("cuenta_referencia", nv ? nv.cuenta : "")
          }}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderInput={(params) => <TextField {...params} label="Banco de la Empresa (Receptor) *" size="small" />}
        />
      </Grid>

      {/* 2. Tipo de Transacción Bancaria (bcobtran) */}
      <Grid item xs={12} md={6}>
        <Autocomplete
          options={cat.transacciones_cxp || []}
          getOptionLabel={(option) => option.label || ""}
          value={(cat.transacciones_cxp || []).find((t) => t.id === pago.ttrcodigo) || null}
          onChange={(e, nv) => handleInputChange("ttrcodigo", nv ? nv.id : "")}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderInput={(params) => <TextField {...params} label="Tipo de Transacción Bancaria *" size="small" />}
        />
      </Grid>

      {/* 3. Número de Transferencia / Papeleta */}
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Nº de Transferencia / Documento *"
          size="small"
          value={pago.cheque_transf || ""}
          onChange={(e) => handleInputChange("cheque_transf", e.target.value)}
        />
      </Grid>

      {/* 4. Número de Cuenta (Autollenado por el banco seleccionado) */}
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Nº Cuenta Bancaria"
          size="small"
          value={pago.cuenta_referencia || ""}
          InputProps={{ readOnly: true }}
          disabled
        />
      </Grid>

      {/* 5. Fecha de Depósito / Transferencia */}
      <Grid item xs={12} sm={4}>
        <CustomDatePicker
          label="Fecha de Transferencia *"
          value={pago.fecha}
          setValue={(v) => handleInputChange("fecha", v)}
          format="DD/MM/YYYY"
        />
      </Grid>

      {/* 6. Propina (Regla de negocio adicional para transferencias) */}
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Propina (Opcional)"
          size="small"
          type="number"
          value={pago.propina || ""}
          onChange={(e) => handleInputChange("propina", e.target.value)}
          inputProps={{ min: 0, step: "0.01" }}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
      </Grid>
    </>
  )
}

export default TabTransferencia
